module.exports = __webpack_public_path__ + "assets/img/help_start.60e360c9.svg";